import { EditableContent } from '../../edit/EditableContent';
import { pickBlockField } from '../../lib/localized';
import type { BlockRenderProps } from '../../types';

function parseCourses(raw: string): string[] {
  return raw
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

/** Degustation as procession cards — pairing seals sit above the courses. */
export function TastingMenuPairingCards({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const heading = pickBlockField(block.content, 'heading', locale);
  const supporting = pickBlockField(block.content, 'supporting', locale);
  const courses = parseCourses(pickBlockField(block.content, 'courses', locale));
  const pairingWine = pickBlockField(block.content, 'pairingWine', locale);
  const pairingZero = pickBlockField(block.content, 'pairingZero', locale);
  const target = isActive ? activeEditTarget : null;
  const showPairings = Boolean(editable || pairingWine.trim() || pairingZero.trim());

  return (
    <section
      className={['ws-tasting-pairing', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      data-registry-key={block.registryBlockKey}
      id="tasting"
    >
      <div className="ws-tasting-pairing__inner">
        <header className="ws-tasting-pairing__intro">
          <EditableContent
            as="h2"
            fieldKey="heading"
            editable={editable}
            activeEditTarget={target}
            className="ws-tasting-pairing__title"
          >
            {heading}
          </EditableContent>
          <EditableContent
            fieldKey="supporting"
            editable={editable}
            activeEditTarget={target}
            className="ws-tasting-pairing__subtitle"
          >
            {supporting}
          </EditableContent>
        </header>
        {showPairings ? (
          <div className="ws-tasting-pairing__seals">
            <EditableContent
              fieldKey="pairingWine"
              editable={editable}
              activeEditTarget={target}
              className="ws-tasting-pairing__seal"
            >
              {pairingWine}
            </EditableContent>
            <EditableContent
              fieldKey="pairingZero"
              editable={editable}
              activeEditTarget={target}
              className="ws-tasting-pairing__seal"
            >
              {pairingZero}
            </EditableContent>
          </div>
        ) : null}
        <ol className="ws-tasting-pairing__courses">
          {courses.map((course, index) => (
            <li key={`${course}-${index}`} className="ws-tasting-pairing__course">
              <span className="ws-tasting-pairing__index">{String(index + 1).padStart(2, '0')}</span>
              <span className="ws-tasting-pairing__label">{course}</span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
